import {CALL_API} from '../../middleware/api';

// 请假记录
export const LEAVE_RECORD_REQUEST = 'LEAVE_RECORD_REQUEST'
export const LEAVE_RECORD_SUCCESS = 'LEAVE_RECORD_SUCCESS'
export const LEAVE_RECORD_FAILURE = 'LEAVE_RECORD_FAILURE'

// page=1
export function getLeaveRecord(params) {
	return {
		[CALL_API]: {
			types: [LEAVE_RECORD_REQUEST, LEAVE_RECORD_SUCCESS, LEAVE_RECORD_FAILURE],
			endpoint: 'workflow/leave/search',
      methods: 'GET',
      params
		}
	}
}

export default (params) => {
	return (dispatch) => {
		return dispatch(getLeaveRecord(params));
	};
};


// WEBPACK FOOTER //
// ./src/action/leave/leaveRecord.js